import React from 'react';
import { array, bool, func, string } from 'prop-types';

import { contentRangeInput } from '../budget-modal';
import { BudgetCheckbox } from '../budget-modal/styled-components';
import { thousandSeparator } from '../../utils';
import { BudgetView, FormField, FormFieldActions, FormFieldButton } from './styled-components';

export const BudgetContent = ({
  isRange,
  editBudget,
  cancelBudget,
  errorMessage,
  setEditBudget,
  budgetHandler,
  defaultBudget,
  checkboxHandler,
  minBudgetHandler,
  maxBudgetHandler,
  getFieldDecorator,
  disableChangeBudgetBtn,
  setDisableChangeBudgetBtn,
}) => editBudget ? (<FormField>
  {contentRangeInput(
    errorMessage,
    getFieldDecorator,
    defaultBudget,
    minBudgetHandler,
    maxBudgetHandler,
    isRange,
  )}
  <div>
    <BudgetCheckbox checked={isRange} onClick={checkboxHandler}>
        Range
    </BudgetCheckbox>
  </div>
  <FormFieldActions>
    <FormFieldButton onClick={budgetHandler}>Save</FormFieldButton>
    <FormFieldButton onClick={cancelBudget} cancel >Cancel changes</FormFieldButton>
  </FormFieldActions>
</FormField>) :
  (<div>
    <BudgetView>
      {`$${thousandSeparator(defaultBudget[0])} `}
      {defaultBudget[1] && `- $${thousandSeparator(defaultBudget[1])} `}
    </BudgetView>
    <FormFieldActions>
      <FormFieldButton onClick={() => {
        if (disableChangeBudgetBtn) {
          setDisableChangeBudgetBtn(false);
        }
        setEditBudget(true);
      }}
      >Edit
      </FormFieldButton>
      <FormFieldButton
        disabled={disableChangeBudgetBtn}
        onClick={cancelBudget}
        cancel
      >Cancel changes
      </FormFieldButton>
    </FormFieldActions>
  </div>);

BudgetContent.propTypes = {
  isRange: bool.isRequired,
  editBudget: bool.isRequired,
  cancelBudget: func.isRequired,
  errorMessage: string.isRequired,
  setEditBudget: bool.isRequired,
  budgetHandler: bool.isRequired,
  defaultBudget: array.isRequired,
  checkboxHandler: func.isRequired,
  minBudgetHandler: func.isRequired,
  maxBudgetHandler: func.isRequired,
  getFieldDecorator: func.isRequired,
  disableChangeBudgetBtn: bool.isRequired,
  setDisableChangeBudgetBtn: func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modals/change-status/budget.js